import { Helmet } from "react-helmet";
import { InshurAnnouncementBar } from "../Home/components/InshurAnnouncementBar";
import { InshurHero } from "../Home/components/InshurHero";
import { InshurBenefits } from "../Home/components/InshurBenefits";
import { HomeShowcase } from "../Home/components/HomeShowcase";
import { ProductRail } from "../Home/components/ProductRail";
import { InshurLandingContext } from "../Home/landingMode";
import "../Home/home.css";

const TITLE = "Rentid × INSHUR — The rental operating system for independent hosts";
const DESCRIPTION =
  "Run your own direct rental business on Rentid. Your brand, your customers, your terms — bookings, agreements, payments, and protection in one place.";
const URL = "https://www.rentid.io/inshur";

/* /inshur, mirroring the v0 prototype's app/inshurlandingpage/page.tsx
   (origin/v0/update-hero-sub-copy, 920fc60, 2026-09-30): no site header; an INSHUR announcement
   bar; a LIGHT top half (his hero + the INSHUR benefits section, on the light theme tokens); then
   the shared home page sections with the RentShield + INSHUR co-brand logo; and the product rail.
   The hero images are the ones our /inshurlp page already ships in public/img/inshurlp.

   Owner's rule (2026-09-30): the only ways off this page are leaving the site or the hero's
   "Get Started" button. InshurLandingContext puts every shared section into landing mode (cards
   stop being links, "Learn more" / Book Demo / API Access / Start for free are not rendered, the
   rail keeps only its in-page shortcuts), and the site footer with its links is left off. */
export default function InshurLandingPage() {
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
        <meta name="description" content={DESCRIPTION} />
        <meta property="og:title" content={TITLE} />
        <meta property="og:description" content={DESCRIPTION} />
        <meta property="og:url" content={URL} />
        <link rel="canonical" href={URL} />
      </Helmet>
      <InshurLandingContext.Provider value={true}>
      <div className="rd-home">
        <main className="home-fade-in min-h-screen overflow-x-hidden bg-black">
          <InshurAnnouncementBar />
          <div>
            <div className="bg-background text-foreground">
              <InshurHero
                images={[
                  {
                    src: "/img/inshurlp/inshurlp-couple-hero.png",
                    alt: "A smiling couple holding up a car key in a sunny dealership lot with a row of rental cars behind them",
                    fit: "cover",
                    position: "78% center",
                  },
                ]}
              />
              <InshurBenefits />
            </div>
          </div>
          <HomeShowcase cobrand />
        </main>
        {/* Outside <main> for the same reason as on the home page (see Home.jsx). */}
        <ProductRail />
      </div>
      </InshurLandingContext.Provider>
    </>
  );
}
